import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Crea una timeline GSAP con ScrollTrigger one-shot, OPPURE fa partire
 * l'animazione immediatamente se il blocco è già in viewport al load.
 *
 * Risolve il caso: utente carica una pagina dove un blocco animato è già
 * visibile (es. above-the-fold) → ScrollTrigger potrebbe non scattare
 * coerentemente. Con questa funzione: se il blocco è già sopra la trigger
 * line al load, l'animazione parte subito; altrimenti ScrollTrigger normale.
 *
 * Uso:
 *   const tl = gsap.timeline({ paused: true });
 *   tl.to(...).to(...);
 *   attachScrollTriggerOrPlayNow(tl, {
 *     trigger: block,
 *     start: "top 85%",
 *     onComplete: () => block.setAttribute("data-ready", "true"),
 *   });
 *
 * @param {gsap.core.Timeline} timeline - timeline GSAP (deve essere paused)
 * @param {Object} config
 * @param {HTMLElement} config.trigger - elemento DOM trigger
 * @param {string} [config.start="top 85%"] - posizione di start ScrollTrigger
 * @param {Function} [config.onComplete] - callback alla fine dell'animazione
 */
export const attachScrollTriggerOrPlayNow = (timeline, config) => {
  const { trigger, start = "top 85%", onComplete } = config;

  if (!trigger) return;

  // Setup onComplete sulla timeline (sia per play subito che per ScrollTrigger)
  if (onComplete) {
    timeline.eventCallback("onComplete", onComplete);
  }

  // Calcolo se il blocco è già "passato" la trigger line
  // "top 85%" significa: trigger scatta quando il top del block raggiunge
  // l'85% del viewport (cioè quando entra dal basso). Se top < 85% viewport,
  // l'elemento è già in viewport o sopra.
  const rect = trigger.getBoundingClientRect();
  const triggerLine = window.innerHeight * 0.85;

  if (rect.top < triggerLine) {
    // Già passata la trigger line al load → parti subito
    // requestAnimationFrame garantisce che il browser abbia paintato lo
    // stato iniziale (gsap.set inline) prima di iniziare il tween
    requestAnimationFrame(() => {
      timeline.play(0);
    });
  } else {
    // ScrollTrigger normale per blocchi sotto il fold
    ScrollTrigger.create({
      trigger,
      start,
      toggleActions: "play none none none",
      onEnter: () => timeline.play(0),
    });
  }
};